<template>
  <v-container fluid>
    <v-form ref="formData" v-model="valid" lazy-validation>
      <v-tabs v-model="tab" grow>
        <v-tab>Infraestrutura</v-tab>
        <v-tab>Recursos</v-tab>
        <v-tab>Equipamentos</v-tab>
        <v-tab>Funcionários</v-tab>
        <v-tab>Outros</v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <!-- ABA 1: INFRAESTRUTURA -->
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <v-subheader class="pl-0">Local de Funcionamento</v-subheader>
              <v-row>
                <v-col cols="12" md="6">
                  <v-checkbox
                    v-model="formData.predio_escolar"
                    label="Prédio escolar"
                    :true-value="1"
                    :false-value="0"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="formData.salas_outra_escola"
                    label="Sala(s) em outra escola"
                    :true-value="1"
                    :false-value="0"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="formData.galpao_rancho"
                    label="Galpão/rancho/paiol/barracão"
                    :true-value="1"
                    :false-value="0"
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" md="6">
                  <v-checkbox
                    v-model="formData.unidade_socioeducativa"
                    label="Unidade socioeducativa"
                    :true-value="1"
                    :false-value="0"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="formData.unidade_prisional"
                    label="Unidade prisional"
                    :true-value="1"
                    :false-value="0"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="formData.outros_local_func"
                    label="Outros locais"
                    :true-value="1"
                    :false-value="0"
                  ></v-checkbox>
                </v-col>
              </v-row>

              <v-subheader class="pl-0">Ocupação do Prédio</v-subheader>
              <v-row>
                <v-col cols="12" md="6">
                  <v-select
                    v-if="formData.predio_escolar === 1"
                    v-model="formData.forma_ocupacao_predio"
                    :items="ocupacaoOptions"
                    label="Forma de ocupação"
                    clearable
                  ></v-select>
                </v-col>
                <v-col cols="12" md="6">
                  <v-checkbox
                    v-if="formData.predio_escolar === 1"
                    v-model="formData.predio_compartilhado"
                    label="Prédio compartilhado com outra escola"
                    :true-value="1"
                    :false-value="0"
                  ></v-checkbox>
                </v-col>
              </v-row>

              <div v-if="formData.predio_compartilhado">
                <v-subheader class="pl-0">Escolas Compartilhadas</v-subheader>
                <v-row>
                  <v-col cols="12" md="4" v-for="n in 6" :key="n">
                    <v-text-field
                      v-model="formData[`codigo_compartilha_${n}`]"
                      :label="`Código INEP Escola ${n}`"
                      maxlength="8"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </div>

              <v-subheader class="pl-0">Recursos Básicos</v-subheader>
              <v-row>
                <v-col cols="12" md="4">
                  <v-subheader>Fornece água potável para o consumo humano?</v-subheader>
                  <v-checkbox
                    v-if="!formData.nao_ha_agua"
                    v-model="formData.agua_potavel"
                    label="Sim, Água potável"
                    :true-value="1"
                    :false-value="0"
                  ></v-checkbox>
                </v-col>
              </v-row>
              <v-col cols="12" md="8">
                Sobre A água
                <v-checkbox
                  v-if="!formData.nao_ha_agua"
                  v-model="formData.rede_publica_agua"
                  label="Rede pública"
                  :true-value="1"
                  :false-value="0"
                ></v-checkbox>
                <v-checkbox
                  v-if="!formData.nao_ha_agua"
                  v-model="formData.poco_artesiano"
                  label="Poço artesiano"
                  :true-value="1"
                  :false-value="0"
                ></v-checkbox>
                <v-checkbox
                  v-if="!formData.nao_ha_agua"
                  v-model="formData.cisterna"
                  label="Cisterna"
                  :true-value="1"
                  :false-value="0"
                ></v-checkbox>
                <v-checkbox
                  v-if="!formData.nao_ha_agua"
                  v-model="formData.fonte_rio"
                  label="Fonte/rio"
                  :true-value="1"
                  :false-value="0"
                ></v-checkbox>
                <v-checkbox
                  v-if="!formData.nao_ha_agua"
                  v-model="formData.carro_pipa"
                  label="Carro-pipa"
                  :true-value="1"
                  :false-value="0"
                ></v-checkbox>
                <v-checkbox
                  v-model="formData.nao_ha_agua"
                  label="Não há água"
                  :true-value="1"
                  :false-value="0"
                ></v-checkbox>
              </v-col>

              <v-col cols="12" md="4">
                <v-subheader>Energia</v-subheader>
                <v-checkbox
                  v-if="!formData.nao_ha_energia"
                  v-model="formData.rede_publica_energia"
                  label="Rede pública"
                  :true-value="1"
                  :false-value="0"
                ></v-checkbox>
                <v-checkbox
                  v-if="!formData.nao_ha_energia"
                  v-model="formData.gerador_combustivel"
                  label="Gerador a combustível"
                  :true-value="1"
                  :false-value="0"
                ></v-checkbox>
                <v-checkbox
                  v-if="!formData.nao_ha_energia"
                  v-model="formData.energia_renovavel"
                  label="Energia renovável"
                  :true-value="1"
                  :false-value="0"
                ></v-checkbox>
                <v-checkbox
                  v-model="formData.nao_ha_energia"
                  label="Não há energia"
                  :true-value="1"
                  :false-value="0"
                ></v-checkbox>
              </v-col>
              <v-row>
                <v-col cols="12" md="4">
                  <v-subheader>Esgoto</v-subheader>
                  <v-checkbox
                    v-if="!formData.nao_ha_esgoto"
                    v-model="formData.rede_publica_esgoto"
                    label="Rede pública"
                    :true-value="1"
                    :false-value="0"
                  ></v-checkbox>
                  <v-checkbox
                    v-if="!formData.nao_ha_esgoto"
                    v-model="formData.fossa_septica"
                    label="Fossa séptica"
                    :true-value="1"
                    :false-value="0"
                  ></v-checkbox>
                  <v-checkbox
                    v-if="!formData.nao_ha_esgoto"
                    v-model="formData.fossa_rudimentar"
                    label="Fossa rudimentar"
                    :true-value="1"
                    :false-value="0"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="formData.nao_ha_esgoto"
                    label="Não há esgoto"
                    :true-value="1"
                    :false-value="0"
                  ></v-checkbox>
                </v-col>
              </v-row>

              <v-subheader class="pl-0">Destinação do Lixo</v-subheader>
              <v-row>
                <v-col cols="12" md="6">
                  <v-checkbox
                    v-model="formData.coleta_lixo"
                    label="Coleta"
                    :true-value="1"
                    :false-value="0"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="formData.queima_lixo"
                    label="Queima"
                    :true-value="1"
                    :false-value="0"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="formData.enterra_lixo"
                    label="Enterra"
                    :true-value="1"
                    :false-value="0"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="formData.destinacao_licenciada"
                    label="Destinação licenciada"
                    :true-value="1"
                    :false-value="0"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="formData.descarta_outra_area"
                    label="Descarta em outra área"
                    :true-value="1"
                    :false-value="0"
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" md="6">
                  <v-subheader>Tratamento do Lixo</v-subheader>
                  <v-checkbox
                    v-if="!formData.nao_faz_tratamento_lixo"
                    v-model="formData.separacao_lixo"
                    label="Separação"
                    :true-value="1"
                    :false-value="0"
                  ></v-checkbox>
                  <v-checkbox
                    v-if="!formData.nao_faz_tratamento_lixo"
                    v-model="formData.reaproveitamento_lixo"
                    label="Reaproveitamento"
                    :true-value="1"
                    :false-value="0"
                  ></v-checkbox>
                  <v-checkbox
                    v-if="!formData.nao_faz_tratamento_lixo"
                    v-model="formData.reciclagem_lixo"
                    label="Reciclagem"
                    :true-value="1"
                    :false-value="0"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="formData.nao_faz_tratamento_lixo"
                    label="Não faz tratamento"
                    :true-value="1"
                    :false-value="0"
                  ></v-checkbox>
                </v-col>
              </v-row>

              <v-subheader class="pl-0">Dependências Físicas</v-subheader>
              <v-row>
                <v-col cols="12" md="4" v-for="(dep, index) in dependenciasPart1" :key="index">
                  <v-checkbox
                    v-if="!formData.nenhuma_dependencia"
                    v-model="formData[dep.field]"
                    :label="dep.label"
                    :true-value="1"
                    :false-value="0"
                  ></v-checkbox>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="4" v-for="(dep, index) in dependenciasPart2" :key="index">
                  <v-checkbox
                    v-if="dep.field === 'nenhuma_dependencia'"
                    v-model="formData[dep.field]"
                    :label="dep.label"
                    :true-value="1"
                    :false-value="0"
                  ></v-checkbox>
                  <v-checkbox
                    v-else-if="!formData.nenhuma_dependencia"
                    v-model="formData[dep.field]"
                    :label="dep.label"
                    :true-value="1"
                    :false-value="0"
                  ></v-checkbox>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-tab-item>

        <!-- ABA 2: RECURSOS -->
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <v-subheader class="pl-0">Acessibilidade</v-subheader>
              <v-row>
                <v-col cols="12" md="4" v-for="(item, index) in acessibilidadeItems" :key="index">
                  <v-checkbox
                    v-if="item.field === 'nenhum_recurso_acessibilidade'"
                    v-model="formData[item.field]"
                    :label="item.label"
                    :true-value="1"
                    :false-value="0"
                  ></v-checkbox>
                  <v-checkbox
                    v-else-if="!formData.nenhum_recurso_acessibilidade"
                    v-model="formData[item.field]"
                    :label="item.label"
                    :true-value="1"
                    :false-value="0"
                  ></v-checkbox>
                </v-col>
              </v-row>

              <v-subheader class="pl-0">Salas de Aula</v-subheader>

              <v-row>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-if="formData.predio_escolar"
                    v-model="formData.salas_aula_predio"
                    :label="'Quantidade de Salas Dentro do Prédio'"
                    type="number"
                    min="0"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-if="formData.salas_outra_escola"
                    v-model="formData.salas_aula_fora_predio"
                    :label="'Quantidade de Salas fora do prédio'"
                    type="number"
                    min="0"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-if="formData.salas_aula_predio > 0 || formData.salas_aula_fora_predio > 0"
                    v-model="formData.salas_aula_climatizadas"
                    :label="'Quantidade de Salas climatizadas'"
                    type="number"
                    min="0"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-if="formData.salas_aula_predio > 0 || formData.salas_aula_fora_predio > 0"
                    v-model="formData.salas_aula_acessiveis"
                    :label="'Quantidade de Salas acessíveis'"
                    type="number"
                    min="0"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="formData.salas_aula_leitura"
                    :label="'Quantidade de Salas com cantinho de leitura'"
                    type="number"
                    min="0"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-subheader class="pl-0">Internet</v-subheader>
              <v-row>
                <v-col cols="12" md="6">
                  <!-- se o uso for adminstrativo -->
                  <v-checkbox
                    v-if="!formData.nao_tem_internet"
                    v-model="formData.internet_admin"
                    label="Uso administrativo"
                    :true-value="1"
                    :false-value="0"
                  ></v-checkbox>

                  <!-- se o uso for ensino e aprendizagem -->
                  <v-checkbox
                    v-if="!formData.nao_tem_internet"
                    v-model="formData.internet_ensino"
                    label="Ensino/aprendizagem"
                    :true-value="1"
                    :false-value="0"
                  ></v-checkbox>

                  <!-- se o uso for uso pro alunos -->
                  <v-checkbox
                    v-if="!formData.nao_tem_internet"
                    v-model="formData.internet_alunos"
                    label="Uso dos alunos"
                    :true-value="1"
                    :false-value="0"
                  ></v-checkbox>
                  <v-row v-if="formData.internet_alunos && !formData.nao_tem_internet">
                    <v-col class="ml-10" cols="12" md="6">
                      <p>Equipamentos que os alunos usam para acessar a internet da escola</p>
                      <v-checkbox
                        v-model="formData.alunos_acessam_internet_comp_mesa_lab"
                        label="Computadores de mesa, portáteis e tablets da escola (no laboratório de informática, biblioteca, sala de aula etc.)"
                        :true-value="1"
                        :false-value="0"
                      ></v-checkbox>
                      <v-checkbox
                        v-model="formData.alunos_acessam_disp_pessoais"
                        label="Dispositivos pessoais (computadores portáteis, celulares, tablets etc.)"
                        :true-value="1"
                        :false-value="0"
                      ></v-checkbox>
                      <v-checkbox
                        v-model="formData.alunos_acessam_internet_bandalarga"
                        label="Internet banda larga"
                        :true-value="1"
                        :false-value="0"
                      ></v-checkbox>
                    </v-col>
                  </v-row>

                  <!-- se o uso for comunidade -->
                  <v-checkbox
                    v-if="!formData.nao_tem_internet"
                    v-model="formData.internet_comunidade"
                    label="Uso da comunidade"
                    :true-value="1"
                    :false-value="0"
                  ></v-checkbox>

                  <!-- se nao possui internet -->
                  <v-checkbox
                    v-model="formData.nao_tem_internet"
                    label="Não possui internet"
                    :true-value="1"
                    :false-value="0"
                  ></v-checkbox>
                </v-col>
              </v-row>

              <v-subheader class="pl-0">Rede local de interligação de computadores</v-subheader>
              <v-row>
                <v-col cols="12" md="6">
                  <v-checkbox
                    v-if="!formData.nao_tem_internet"
                    v-model="formData.rede_local_cabo"
                    label="A cabo"
                    :true-value="1"
                    :false-value="0"
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" md="6">
                  <v-checkbox
                    v-if="!formData.nao_tem_internet"
                    v-model="formData.rede_local_wireless"
                    label="Wirelles"
                    :true-value="1"
                    :false-value="0"
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" md="6">
                  <v-checkbox
                    v-if="!formData.sem_rede"
                    v-model="formData.rede_local_sem_rede"
                    label="Não há rede local interligando computadores"
                    :true-value="1"
                    :false-value="0"
                  ></v-checkbox>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-tab-item>

        <!-- ABA 3: EQUIPAMENTOS -->
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <v-subheader class="pl-0">Equipamentos Administrativos</v-subheader>
              <v-row>
                <v-col
                  cols="12"
                  md="4"
                  v-for="(item, index) in equipamentosAdminItems"
                  :key="index"
                >
                  <v-checkbox
                    v-model="formData[item.field]"
                    :label="item.label"
                    :true-value="1"
                    :false-value="0"
                  ></v-checkbox>
                </v-col>
              </v-row>

              <v-subheader class="pl-0">Equipamentos para Ensino</v-subheader>
              <v-row>
                <v-col
                  cols="12"
                  md="4"
                  v-for="(item, index) in equipamentosEnsinoItems"
                  :key="index"
                >
                  <v-checkbox
                    v-model="formData[item.field]"
                    :label="item.label"
                    :true-value="1"
                    :false-value="null"
                  ></v-checkbox>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-tab-item>

        <!-- ABA 4: FUNCIONÁRIOS -->
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <v-subheader class="pl-0">Funcionários</v-subheader>
              <legend>Preencha a quantidade apenas se houver funcionários</legend>
              <v-row v-if="!formData.nenhum_funcionario">
                <v-col cols="12" md="6" v-for="(item, index) in funcionariosItems" :key="index">
                  <v-text-field
                    v-model="formData[item.field]"
                    :label="item.label"
                    min="0"
                    type="number"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-col cols="12">
                <v-checkbox
                  v-model="formData.nenhum_funcionario"
                  label="Não há funcionários para as funções listadas"
                  :true-value="1"
                  :false-value="0"
                ></v-checkbox>
              </v-col>
            </v-card-text>
          </v-card>
        </v-tab-item>

        <!-- ABA 5: OUTROS -->
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <v-subheader class="pl-0">Alimentação Escolar</v-subheader>
              <v-row>
                <v-col cols="12">
                  <v-select
                    :items="['0-Não Oferece', '1-Oferece']"
                    item-text="descricao"
                    item-value="id"
                    v-model="formData.alimentacao_escolar"
                    label="Selecione"
                    solo
                    class="px-2"
                  ></v-select>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-text>
              <v-subheader class="pl-0">Materiais Pedagógicos</v-subheader>
              <v-row>
                <v-col cols="12" md="4" v-for="(item, index) in materiaisItems" :key="index">
                  <v-checkbox
                    v-if="item.field == 'nenhum_materiais'"
                    v-model="formData.nenhum_materiais"
                    :label="item.label"
                    :true-value="1"
                    :false-value="0"
                  ></v-checkbox>
                  <v-checkbox
                    v-else-if="!formData.nenhum_materiais"
                    v-model="formData[item.field]"
                    :label="item.label"
                    :true-value="1"
                    :false-value="0"
                  ></v-checkbox>
                </v-col>
              </v-row>

              <v-subheader class="pl-0">Escola Indígena</v-subheader>
              <v-row>
                <v-col cols="12" md="4">
                  <v-checkbox
                    v-model="formData.escola_indigena"
                    label="Escola indígena"
                    :true-value="1"
                    :false-value="0"
                  ></v-checkbox>
                </v-col>
                <v-col v-if="formData.escola_indigena" cols="12" md="12" class="pl-10">
                  <p>Língua em que o ensino é ministrado</p>
                  <v-checkbox
                    v-if="formData.escola_indigena"
                    v-model="formData.lingua_indigena"
                    label="Língua indígena"
                    :true-value="1"
                    :false-value="0"
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" md="12" class="pl-10">
                  <v-checkbox
                    v-if="formData.escola_indigena"
                    v-model="formData.lingua_portuguesa"
                    label="Língua portuguesa"
                    :true-value="1"
                    :false-value="0"
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" md="4" v-for="n in 3" :key="n">
                  <v-text-field
                    v-if="formData.lingua_indigena"
                    v-model="formData[`codigo_lingua_${n}`]"
                    :label="`Código língua indígena ${n}`"
                  ></v-text-field>
                </v-col>
              </v-row>

              <!-- <v-subheader class="pl-0"
                >Reserva de vagas por sistema de cotas para grupos específicos de
                aluno(a)s</v-subheader
              > -->
              <!-- <v-row>
                <v-col cols="12" md="6">
                  <v-checkbox
                    v-model="formData.exame_selecao"
                    label="A escola faz exame de seleção para ingresso de seus aluno(a)s (avaliação por prova e /ou analise curricular)"
                    :true-value="1"
                    :false-value="0"
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" md="6">
                  <v-checkbox
                    v-model="formData.cotas_ppi"
                    label="Cotas PPI"
                    :true-value="1"
                    :false-value="0"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="formData.cotas_renda"
                    label="Cotas por renda"
                    :true-value="1"
                    :false-value="0"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="formData.cotas_escola_publica"
                    label="Cotas escola pública"
                    :true-value="1"
                    :false-value="0"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="formData.cotas_pcd"
                    label="Cotas PCD"
                    :true-value="1"
                    :false-value="0"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="formData.cotas_outros"
                    label="Outras cotas"
                    :true-value="1"
                    :false-value="0"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="formData.cotas_ampla_concorrencia"
                    label="Ampla concorrência"
                    :true-value="1"
                    :false-value="0"
                  ></v-checkbox>
                </v-col>
              </v-row> -->

              <v-subheader class="pl-0">Comunicação e Integração</v-subheader>
              <v-row>
                <v-col cols="12" md="6">
                  <v-checkbox
                    v-model="formData.site_institucional"
                    label="Site institucional"
                    :true-value="1"
                    :false-value="0"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="formData.compartilha_espacos"
                    label="Compartilha espaços"
                    :true-value="1"
                    :false-value="0"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="formData.usa_espacos_entorno"
                    label="Usa espaços do entorno"
                    :true-value="1"
                    :false-value="0"
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" md="6">
                  <v-subheader>Órgãos Colegiados</v-subheader>
                  <v-checkbox
                    v-model="formData.associacao_pais"
                    label="Associação de pais"
                    :true-value="1"
                    :false-value="0"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="formData.associacao_pais_mestres"
                    label="Associação pais e mestres"
                    :true-value="1"
                    :false-value="0"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="formData.conselho_escolar"
                    label="Conselho escolar"
                    :true-value="1"
                    :false-value="0"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="formData.gremio_estudantil"
                    label="Grêmio estudantil"
                    :true-value="1"
                    :false-value="0"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="formData.outros_orgaos_colegiados"
                    label="Outros órgãos"
                    :true-value="1"
                    :false-value="0"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="formData.nao_ha_orgaos_colegiados"
                    label="Não há órgãos"
                    :true-value="1"
                    :false-value="0"
                  ></v-checkbox>
                </v-col>
              </v-row>

              <v-subheader class="pl-0">Projeto Político Pedagógico</v-subheader>
              <v-row>
                <v-col cols="12" md="6">
                  <v-checkbox
                    v-model="formData.ppp_atualizado"
                    label="PPP atualizado nos últimos 12 meses"
                    :true-value="1"
                    :false-value="0"
                  ></v-checkbox>
                </v-col>
              </v-row>

              <v-subheader class="pl-0">Educação Ambiental</v-subheader>
              <v-row>
                <v-col cols="12">
                  <v-checkbox
                    v-model="formData.educacao_ambiental"
                    label="Desenvolve ações de educação ambiental"
                    :true-value="1"
                    :false-value="0"
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" md="6" v-if="formData.educacao_ambiental">
                  <v-checkbox
                    v-if="!formData.ambiental_nenhuma_opcao"
                    v-model="formData.ambiental_conteudo_curricular"
                    label="Como conteúdo curricular"
                    :true-value="1"
                    :false-value="0"
                  ></v-checkbox>
                  <v-checkbox
                    v-if="!formData.ambiental_nenhuma_opcao"
                    v-model="formData.ambiental_componente_especifico"
                    label="Componente específico"
                    :true-value="1"
                    :false-value="0"
                  ></v-checkbox>
                  <v-checkbox
                    v-if="!formData.ambiental_nenhuma_opcao"
                    v-model="formData.ambiental_eixo_estruturante"
                    label="Eixo estruturante"
                    :true-value="1"
                    :false-value="0"
                  ></v-checkbox>
                  <v-checkbox
                    v-if="!formData.ambiental_nenhuma_opcao"
                    v-model="formData.ambiental_eventos"
                    label="Em eventos"
                    :true-value="1"
                    :false-value="0"
                  ></v-checkbox>
                  <v-checkbox
                    v-if="!formData.ambiental_nenhuma_opcao"
                    v-model="formData.ambiental_projetos_transversais"
                    label="Projetos transversais"
                    :true-value="1"
                    :false-value="0"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="formData.ambiental_nenhuma_opcao"
                    label="Nenhuma das opções"
                    :true-value="1"
                    :false-value="0"
                  ></v-checkbox>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs-items>

      <v-row class="mt-4">
        <v-col cols="6">
          <v-btn block color="error" @click="submitForm('prev')">
            <v-icon>mdi-chevron-left</v-icon> Etapa Anterior</v-btn
          >
        </v-col>
        <v-col cols="6">
          <v-btn block color="success" @click="submitForm('next')">
            <v-icon>mdi-chevron-right</v-icon> Próxima Etapa</v-btn
          >
        </v-col>
      </v-row>
      <v-row v-if="erros.length > 0">
        <v-col cols="12" class="mt-4" style="background-color: red; color: white">
          <v-card-title>Erros encontrados no preenchimento dos dados</v-card-title>
          <v-card-text>
            <ul v-for="(erro, index) in erros" :key="index">
              <li>{{ erro.mensagem }}</li>
            </ul>
          </v-card-text>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      valid: true,
      tab: null,
      formData: {
        // Infraestrutura
        predio_escolar: 1,
        salas_outra_escola: 0,
        galpao_rancho: 0,
        unidade_socioeducativa: 0,
        unidade_prisional: 0,
        outros_local_func: 0,
        forma_ocupacao_predio: null,
        predio_compartilhado: 0,
        codigo_compartilha_1: null,
        codigo_compartilha_2: null,
        codigo_compartilha_3: null,
        codigo_compartilha_4: null,
        codigo_compartilha_5: null,
        codigo_compartilha_6: null,
        agua_potavel: 1,
        rede_publica_agua: 0,
        poco_artesiano: 0,
        cisterna: 0,
        fonte_rio: 0,
        carro_pipa: 0,
        nao_ha_agua: 0,
        rede_publica_energia: 0,
        gerador_combustivel: 0,
        energia_renovavel: 0,
        nao_ha_energia: 0,
        rede_publica_esgoto: 0,
        fossa_septica: 0,
        fossa_rudimentar: 0,
        nao_ha_esgoto: 0,
        coleta_lixo: 0,
        queima_lixo: 0,
        enterra_lixo: 0,
        destinacao_licenciada: 0,
        descarta_outra_area: 0,
        separacao_lixo: 0,
        reaproveitamento_lixo: 0,
        reciclagem_lixo: 0,
        nao_faz_tratamento_lixo: 0,
        almoxarifado: 0,
        area_vegetacao: 0,
        auditorio: 0,
        banheiro: 0,
        banheiro_acessivel: 0,
        banheiro_infantil: 0,
        banheiro_funcionarios: 0,
        banheiro_chuveiro: 0,
        biblioteca: 0,
        cozinha: 0,
        despensa: 0,
        dormitorio_alunos: 0,
        dormitorio_professores: 0,
        laboratorio_ciencias: 0,
        laboratorio_informatica: 0,
        laboratorio_profissional: 0,
        parque_infantil: 0,
        patio_coberto: 0,
        patio_descoberto: 0,
        piscina: 0,
        quadra_coberta: 0,
        quadra_descoberta: 0,
        refeitorio: 0,
        sala_repouso: 0,
        sala_artes: 0,
        sala_musica: 0,
        sala_danca: 0,
        sala_multiuso: 0,
        terreirao: 0,
        viveiro: 0,
        sala_diretoria: 0,
        sala_leitura: 0,
        sala_professores: 0,
        sala_recursos_aee: 0,
        sala_secretaria: 0,
        sala_oficinas: 0,
        estudio_gravacao: 0,
        area_horta: 0,
        nenhuma_dependencia: 0,
        // Acessibilidade
        corrimao_guarda_corpo: 0,
        elevador: 0,
        pisos_tateis: 0,
        portas_80cm: 0,
        rampas: 0,
        sinalizacao_luminosa: 0,
        sinalizacao_sonora: 0,
        sinalizacao_tatil: 0,
        sinalizacao_visual: 0,
        nenhum_recurso_acessibilidade: 0,
        // Salas de aula
        salas_aula_predio: null,
        salas_aula_fora_predio: null,
        salas_aula_climatizadas: null,
        salas_aula_acessiveis: null,
        salas_aula_leitura: null,
        // Equipamentos
        antena_parabolica: null,
        computadores_admin: null,
        copiadora: null,
        impressora: null,
        impressora_multifuncional: null,
        scanner: null,
        nenhum_equipamento_admin: null,
        dvd_blu_ray: null,
        aparelho_som: null,
        aparelho_tv: null,
        lousa_digital: null,
        projetor_multimidia: null,
        computadores_mesa: null,
        computadores_portateis: null,
        tablets: null,
        // Internet
        internet_admin: 0,
        internet_ensino: 0,
        internet_alunos: 0,
        internet_comunidade: 0,
        nao_tem_internet: 0,
        equipamentos_internet_escola: [],
        dispositivos_pessoais_internet: [],
        internet_banda_larga: [],
        rede_local_cabo: [],
        rede_local_wireless: [],
        rede_local_sem_rede: [],
        // Funcionários
        agronomos: null,
        auxiliares_secretaria: null,
        auxiliar_servicos_gerais: null,
        bibliotecarios: null,
        profissionais_saude: null,
        coordenador_turno: null,
        fonoaudiologo: null,
        nutricionista: null,
        psicologo_escolar: null,
        profissionais_alimentacao: null,
        profissionais_apoio_pedagogico: null,
        secretario_escolar: null,
        seguranca: null,
        tecnicos_laboratorio: null,
        vice_diretor: null,
        orientador_comunitario: null,
        tradutor_libras: null,
        revisor_braille: null,
        nenhum_funcionario: null,
        // Materiais pedagógicos
        alimentacao_escolar: null,
        acervo_multimidia: 0,
        brinquedos_infantil: 0,
        materiais_cientificos: 0,
        equipamento_som: 0,
        equipamentos_horta: 0,
        instrumentos_musicais: 0,
        jogos_educativos: 0,
        materiais_culturais: 0,
        materiais_profissional: 0,
        materiais_desportivos: 0,
        materiais_bilingue_surdos: 0,
        materiais_indigena: 0,
        materiais_etnico_raciais: 0,
        materiais_campo: 0,
        materiais_quilombola: 0,
        materiais_especial: 0,
        nenhum_instrumento: 0,
        // Escola indígena
        escola_indigena: 0,
        lingua_indigena: null,
        lingua_portuguesa: null,
        codigo_lingua_1: null,
        codigo_lingua_2: null,
        codigo_lingua_3: null,
        // Cotas e seleção
        exame_selecao: 0,
        cotas_ppi: 0,
        cotas_renda: 0,
        cotas_escola_publica: 0,
        cotas_pcd: 0,
        cotas_outros: 0,
        cotas_ampla_concorrencia: 0,
        // Comunicação e integração
        site_institucional: 0,
        compartilha_espacos: 0,
        usa_espacos_entorno: 0,
        // Órgãos colegiados
        associacao_pais: 0,
        associacao_pais_mestres: 0,
        conselho_escolar: 0,
        gremio_estudantil: 0,
        outros_orgaos_colegiados: 0,
        nao_ha_orgaos_colegiados: 0,
        // PPP
        ppp_atualizado: 0,
        // Educação ambiental
        educacao_ambiental: 0,
        ambiental_conteudo_curricular: null,
        ambiental_componente_especifico: null,
        ambiental_eixo_estruturante: null,
        ambiental_eventos: null,
        ambiental_projetos_transversais: null,
        ambiental_nenhuma_opcao: null,
      },
      ocupacaoOptions: [
        { text: "1-Próprio", value: 1 },
        { text: "2-Alugado", value: 2 },
        { text: "3-Cedido", value: 3 },
      ],
      dependenciasPart1: [
        { field: "almoxarifado", label: "Almoxarifado" },
        { field: "area_vegetacao", label: "Área de vegetação" },
        { field: "auditorio", label: "Auditório" },
        { field: "banheiro", label: "Banheiro" },
        { field: "banheiro_acessivel", label: "Banheiro acessível" },
        { field: "banheiro_infantil", label: "Banheiro infantil" },
        { field: "banheiro_funcionarios", label: "Banheiro funcionários" },
        { field: "banheiro_chuveiro", label: "Banheiro com chuveiro" },
        { field: "biblioteca", label: "Biblioteca" },
        { field: "cozinha", label: "Cozinha" },
        { field: "despensa", label: "Despensa" },
        { field: "dormitorio_alunos", label: "Dormitório alunos" },
      ],
      dependenciasPart2: [
        { field: "dormitorio_professores", label: "Dormitório professores" },
        { field: "laboratorio_ciencias", label: "Laboratório ciências" },
        { field: "laboratorio_informatica", label: "Laboratório informática" },
        { field: "laboratorio_profissional", label: "Laboratório profissional" },
        { field: "parque_infantil", label: "Parque infantil" },
        { field: "patio_coberto", label: "Pátio coberto" },
        { field: "patio_descoberto", label: "Pátio descoberto" },
        { field: "piscina", label: "Piscina" },
        { field: "quadra_coberta", label: "Quadra coberta" },
        { field: "quadra_descoberta", label: "Quadra descoberta" },
        { field: "refeitorio", label: "Refeitório" },
        { field: "sala_repouso", label: "Sala de repouso" },

        { field: "sala_atelie_artes", label: "Sala atelie de artes" },
        { field: "sala_musica_coral", label: "Sala de musica/coral" },
        { field: "sala_danca", label: "Sala de danca" },
        { field: "sala_multiuso", label: "Sala multiuso" },
        { field: "terreirao", label: "Terreirao" },
        { field: "viveiro_criacao_animais", label: "Viveiro/criacao de animais" },
        { field: "sala_diretoria", label: "Sala de diretoria" },
        { field: "sala_leitura", label: "Sala de leitura" },
        { field: "sala_professores", label: "Sala de professores" },
        {
          field: "sala_aee",
          label: "Sala de recursos multifuncionais para atendimento educacional especializado",
        },
        { field: "sala_secretaria", label: "Sala de secretaria" },
        {
          field: "salas_oficinas_profissional",
          label: "Salas de oficinas da educacao profissional",
        },
        { field: "estudio_gravacao_edicao", label: "Estudio de gravacao e edicao" },
        { field: "area_horta", label: "Area de horta, plantio e/ou producao agricola" },
        { field: "nenhuma_dependencia", label: "Nenhuma das dependencias relacionadas" },
      ],
      acessibilidadeItems: [
        { field: "corrimao_guarda_corpo", label: "Corrimão e guarda-corpos" },
        { field: "elevador", label: "Elevador" },
        { field: "pisos_tateis", label: "Pisos táteis" },
        { field: "portas_80cm", label: "Portas 80cm" },
        { field: "rampas", label: "Rampas" },
        { field: "sinalizacao_luminosa", label: "Sinalização luminosa" },
        { field: "sinalizacao_sonora", label: "Sinalização sonora" },
        { field: "sinalizacao_tatil", label: "Sinalização tátil" },
        { field: "sinalizacao_visual", label: "Sinalização visual" },
        { field: "nenhum_recurso_acessibilidade", label: "Nenhum recurso de acessibilidade" },
      ],
      salasAulaItems: [
        { field: "salas_aula_predio", label: "Salas dentro do prédio" },
        { field: "salas_aula_fora_predio", label: "Salas fora do prédio" },
        { field: "salas_aula_climatizadas", label: "Salas climatizadas" },
        { field: "salas_aula_acessiveis", label: "Salas acessíveis" },
        { field: "salas_aula_leitura", label: "Salas com cantinho de leitura" },
      ],
      equipamentosAdminItems: [
        { field: "antena_parabolica", label: "Antena parabólica" },
        { field: "computadores_admin", label: "Computadores" },
        { field: "copiadora", label: "Copiadora" },
        { field: "impressora", label: "Impressora" },
        { field: "impressora_multifuncional", label: "Impressora multifuncional" },
        { field: "scanner", label: "Scanner" },
        { field: "nenhum_equipamento_admin", label: "Nenhum equipamento" },
      ],
      equipamentosEnsinoItems: [
        { field: "dvd_blu_ray", label: "DVD/Blu-ray" },
        { field: "aparelho_som", label: "Aparelho de som" },
        { field: "aparelho_tv", label: "Televisão" },
        { field: "lousa_digital", label: "Lousa digital" },
        { field: "projetor_multimidia", label: "Projetor multimídia" },
        { field: "computadores_mesa", label: "Computadores de mesa" },
        { field: "computadores_portateis", label: "Computadores portáteis" },
        { field: "tablets", label: "Tablets" },
      ],
      funcionariosItems: [
        {
          field: "agronomos",
          label:
            "Agrônomos(as), horticultores(as), técnicos ou monitores(as) responsáveis pela gestão da área de horta, plantio e/ou produção agrícola",
        },
        {
          field: "auxiliares_secretaria",
          label: "Auxiliares de secretaria ou auxiliares administrativos, atendentes",
        },
        {
          field: "auxiliar_servicos_gerais",
          label:
            "Auxiliar de serviços gerais, porteiro(a), zelador(a), faxineiro(a), jardineiro(a)",
        },
        {
          field: "bibliotecarios",
          label: "Bibliotecário(a), auxiliar de biblioteca ou monitor(a) da sala de leitura",
        },
        {
          field: "bombeiros",
          label:
            "Bombeiro(a) brigadista, profissionais de assistência a saúde (urgência e emergência), enfermeiro(a), técnico(a) de enfermagem e socorrista",
        },
        { field: "coordenador_turno", label: "Coordenador(a) de turno/disciplinar" },
        { field: "fonoaudiologo", label: "Fonoaudiólogo(a)" },
        { field: "nutricionista", label: "Nutricionista" },
        { field: "psicologo_escolar", label: "Psicólogo(a) escolar" },
        {
          field: "profissionais_alimentacao",
          label:
            "Profissionais de preparação e segação alimentar, cozinheiro(a), merendeira e auxiliar de cozinha",
        },
        {
          field: "profissionais_apoio_pedagogico",
          label:
            "Profissionais de apoio e supervisão pedagógica: (pedagogo(a), coordenador(a) pedagógico(a), orientador(a) educacional, supervisor(a) escolar e coordenador(a) de área de ensino",
        },
        { field: "secretario_escolar", label: "Secretário(a) escolar" },
        { field: "seguranca", label: "Segurança, guarda ou segurança patrimonial" },
        {
          field: "tecnicos_laboratorio",
          label:
            "Técnicos(as), monitores(as), supervisores(as) ou auxiliares de laboratório(s), de apoio a tecnologias educacionais ou em multimeios/multimidias eletrônico-digitais.",
        },
        {
          field: "vice_diretor",
          label:
            "Vice-diretor(a) ou diretor(a) adjunto(a), profissionais responsáveis pela gestão administrativa e/ou financeira",
        },
        {
          field: "orientador_comunitario",
          label: "Orientador(a) comunitário(a) ou assistente social",
        },
        {
          field: "tradutor_libras",
          label:
            "Tradutor e Intérprete de Libras para atendimento em outros ambientes da escola que não seja sala de aula",
        },
        {
          field: "revisor_braille",
          label:
            "Revisor de texto Braille, assistente vidente (assistente de revisão do texto em Braille)",
        },
      ],

      // Acervo multimídia Brinquedos para educação infantil Conjunto de materiais científicos Equipamento para amplificação e difusão de som/áudio Equipamentos e instrumentos para atividades em área de horta, plantio e/ou produção agrícola Instrumentos musicais para conjunto, banda/fanfarra e/ou aulas de música Jogos educativos Materiais para atividades culturais e artísticas Materiais para educação profissional Materiais para prática desportiva e recreação Materiais pedagógicos para a educação bilíngue de surdos Materiais pedagógicos para a educação escolar indígena Materiais pedagógicos para a educação das relações étnicos raciais Materiais pedagógicos para a educação do campo Materiais pedagógicos para a educação escolar quilombola Materiais pedagógicos para a educação especial Nenhum dos instrumentos listados
      /*
      alimentacao_escolar: 0,
        acervo_multimidia: 0,
        brinquedos_infantil: 0,
        materiais_cientificos: 0,
        equipamento_som: 0,
        equipamentos_horta: 0,
        instrumentos_musicais: 0,
        jogos_educativos: 0,
        materiais_culturais: 0,
        materiais_profissional: 0,
        materiais_desportivos: 0,
        materiais_bilingue_surdos: 0,
        materiais_indigena: 0,
        materiais_etnico_raciais: 0,
        materiais_campo: 0,
        materiais_quilombola: 0,
        materiais_especial: 0,
        nenhum_instrumento: 0,
        */

      materiaisItems: [
        { field: "brinquedos_infantil", label: "Brinquedos para educação infantil" },
        { field: "materiais_cientificos", label: "Conjunto de materiais científicos" },
        {
          field: "equipamento_som",
          label: "Equipamento para amplificação e difusão de som/áudio",
        },
        {
          field: "equipamentos_horta",
          label:
            "Equipamentos e instrumentos para atividades em área de horta, plantio e/ou produção agrícola",
        },
        {
          field: "instrumentos_musicais",
          label: "Instrumentos musicais para conjunto, banda/fanfarra e/ou aulas de musica",
        },
        { field: "jogos_educativos", label: "Jogos educativos" },
        {
          field: "materiais_culturais",
          label: "Materiais para atividades culturais e artísticas",
        },
        { field: "materiais_profissional", label: "Materiais para educação profissional" },
        {
          field: "materiais_desportivos",
          label: "Materiais para prática desportiva e recreação",
        },
        {
          field: "materiais_bilingue_surdos",
          label: "Materiais pedagógicos para a educação bilíngue de surdos",
        },
        {
          field: "materiais_indigena",
          label: "Materiais pedagógicos para a educação escolar indígena",
        },
        {
          field: "materiais_etnico_raciais",
          label: "Materiais pedagógicos para a educação das relações étnicos raciais",
        },
        {
          field: "materiais_campo",
          label: "Materiais pedagógicos para a educação do campo",
        },
        {
          field: "materiais_quilombola",
          label: "Materiais pedagógicos para a educação quilombola",
        },
        {
          field: "materiais_especial",
          label: "Materiais pedagógicos para a educação especial",
        },
        { field: "nenhum_instrumento", label: "Nenhum dos instrumentos listados" },
      ],
      erros: [],
    };
  },

  mounted() {
    this.getData();
  },

  methods: {
    async getData() {
      this.$loaderService.open("Carregando...");
      const data = await this.$services.censoService.getData("aba10");
      this.formData = data;
      // if (data.censo10) {
      //   this.formData = data.censo10;
      // }
      this.$loaderService.close();
    },

    submitForm(type) {
      this.save(type);
    },

    validacao() {
      this.erros = [];

      // Função auxiliar para validar grupos de campos
      const validarGrupoCampos = (tipo, mensagem, campos) => {
        const algumMarcado = campos.some((campo) => this.formData[campo]);
        if (algumMarcado) {
          this.erros = this.erros.filter((e) => e.tipo !== tipo);
        } else {
          this.erros.push({ tipo, mensagem });
        }
      };

      // ===== LOCAL DE FUNCIONAMENTO =====
      const camposLocalFunc = [
        "predio_escolar",
        "salas_outra_escola",
        "galpao_rancho",
        "unidade_socioeducativa",
        "unidade_prisional",
        "outros_local_func",
      ];
      validarGrupoCampos(
        "local_funcionamento",
        "Pelo menos um dos campos do local de funcionamento deve ser preenchido.",
        camposLocalFunc
      );

      // ===== FORMA DE OCUPAÇÃO DO PRÉDIO ESCOLAR =====
      if (this.formData.predio_escolar) {
        if (this.formData.forma_ocupacao_predio === null) {
          this.erros.push({
            tipo: "forma_ocupacao_predio",
            mensagem: "Pelo menos uma das formas de ocupação do prédio deve ser preenchida.",
          });
        } else {
          this.erros = this.erros.filter((e) => e.tipo !== "forma_ocupacao_predio");
        }
      }

      // ===== tem ÁGUA? =====
      const agua = ["agua_potavel"];
      validarGrupoCampos("agua", "A pergunta se tem água não foi respondida.", agua);
      // ===== ABASTECIMENTO DE ÁGUA =====
      const camposAgua = [
        "rede_publica_agua",
        "poco_artesiano",
        "cisterna",
        "fonte_rio",
        "carro_pipa",
        "nao_ha_agua",
      ];
      validarGrupoCampos(
        "abastecimento_agua",
        "O abastecimento de água deve ser preenchido.",
        camposAgua
      );

      // ===== FONTE DE ENERGIA =====
      const camposEnergia = [
        "rede_publica_energia",
        "gerador_combustivel",
        "energia_renovavel",
        "nao_ha_energia",
      ];
      validarGrupoCampos(
        "fonte_energia",
        "O abastecimento de energia elétrica deve ser preenchido.",
        camposEnergia
      );

      // ===== ESGOTO =====
      const camposEsgoto = [
        "rede_publica_esgoto",
        "fossa_septica",
        "fossa_rudimentar",
        "nao_ha_esgoto",
      ];
      validarGrupoCampos("esgoto", "O esgoto deve ser preenchido.", camposEsgoto);

      // ===== DESTINAÇÃO DO LIXO =====
      const camposLixo = [
        "coleta_lixo",
        "queima_lixo",
        "enterra_lixo",
        "destinacao_licenciada",
        "descarta_outra_area",
      ];
      validarGrupoCampos(
        "destinacao_lixo",
        "A destinação do lixo deve ser preenchida.",
        camposLixo
      );

      // ===== TRATAMENTO DO LIXO =====
      const camposTratamento = [
        "separacao_lixo",
        "reaproveitamento_lixo",
        "reciclagem_lixo",
        "nao_faz_tratamento_lixo",
      ];
      validarGrupoCampos(
        "tratamento_lixo",
        "O tratamento do lixo deve ser preenchido.",
        camposTratamento
      );

      // ===== DEPENDÊNCIAS FÍSICAS DA ESCOLA =====
      const camposDependencias = [
        "almoxarifado",
        "area_vegetacao",
        "auditorio",
        "banheiro",
        "banheiro_acessivel",
        "banheiro_infantil",
        "banheiro_funcionarios",
        "banheiro_chuveiro",
        "biblioteca",
        "cozinha",
        "despensa",
        "dormitorio_alunos",
        "dormitorio_professores",
        "laboratorio_ciencias",
        "laboratorio_informatica",
        "laboratorio_profissional",
        "parque_infantil",
        "patio_coberto",
        "patio_descoberto",
        "piscina",
        "quadra_coberta",
        "quadra_descoberta",
        "refeitorio",
        "sala_repouso",
        "sala_artes",
        "sala_musica",
        "sala_danca",
        "sala_multiuso",
        "terreirao",
        "viveiro",
        "sala_diretoria",
        "sala_leitura",
        "sala_professores",
        "sala_recursos_aee",
        "sala_secretaria",
        "sala_oficinas",
        "estudio_gravacao",
        "area_horta",
        "nenhuma_dependencia",
      ];
      validarGrupoCampos(
        "dependencias_fisicas",
        "As dependências físicas da escola devem ser preenchidas.",
        camposDependencias
      );

      // ===== RECURSOS DE ACESSIBILIDADE =====

      const camposAcessibilidade = [
        "corrimao_guarda_corpo",
        "elevador",
        "pisos_tateis",
        "portas_80cm",
        "rampas",
        "sinalizacao_luminosa",
        "sinalizacao_sonora",
        "sinalizacao_tatil",
        "sinalizacao_visual",
        "nenhum_recurso_acessibilidade",
      ];
      validarGrupoCampos(
        "acessibilidade",
        "Os recursos de acessibilidade devem ser preenchidos.",
        camposAcessibilidade
      );

      const salasQtd = [
        "salas_aula_predio",
        "salas_aula_climatizadas",
        "salas_aula_acessiveis",
        "salas_aula_leitura",
      ];
      validarGrupoCampos(
        "salas_de_aula_qtd",
        "As quantidades de salas de aula devem ser preenchidos.",
        salasQtd
      );

      const equipamentos = [
        "antena_parabolica",
        "computadores_admin",
        "copiadora",
        "impressora",
        "impressora_multifuncional",
        "scanner",
        "nenhum_equipamento_admin",
        "dvd_blu_ray",
        "aparelho_som",
        "aparelho_tv",
        "lousa_digital",
        "projetor_multimidia",
        "computadores_mesa",
        "computadores_portateis",
        "tablets",
      ];
      validarGrupoCampos(
        "equipamentos",
        'devem ser preenchidos pelo menos um equipamento ou se não existir equipamento marque o campo "nenhum equipamento".',
        equipamentos
      );

      const rede = ["rede_local_cabo", "rede_local_wireless", "rede_local_sem_rede"];
      validarGrupoCampos(
        "rede",
        "A rede local de interligação  dos computadores deve ser preenchida.",
        rede
      );

      const funcionarios = [
        "agronomos",
        "auxiliares_secretaria",
        "auxiliar_servicos_gerais",
        "bibliotecarios",
        "profissionais_saude",
        "coordenador_turno",
        "fonoaudiologo",
        "nutricionista",
        "psicologo_escolar",
        "profissionais_alimentacao",
        "profissionais_apoio_pedagogico",
        "secretario_escolar",
        "seguranca",
        "tecnicos_laboratorio",
        "vice_diretor",
        "orientador_comunitario",
        "tradutor_libras",
        "revisor_braille",
        "nenhum_funcionario",
      ];
      validarGrupoCampos("funcionarios", "Os funcionários devem ser preenchidos.", funcionarios);

      const materiais = [
        "acervo_multimidia",
        "brinquedos_infantil",
        "materiais_cientificos",
        "equipamento_som",
        "equipamentos_horta",
        "instrumentos_musicais",
        "jogos_educativos",
        "materiais_culturais",
        "materiais_profissional",
        "materiais_desportivos",
        "materiais_bilingue_surdos",
        "materiais_indigena",
        "materiais_etnico_raciais",
        "materiais_campo",
        "materiais_quilombola",
        "materiais_especial",
        "nenhum_instrumento",
      ];
      validarGrupoCampos("materiais", "Os materiais pedagógicos devem ser preenchidos.", materiais);

      const alimentacao = ["alimentacao_escolar"];
      validarGrupoCampos("alimentacao", "A alimentação escolar deve ser preenchida.", alimentacao);

      /*
     associacao_pais: 0,
        associacao_pais_mestres: 0,
        conselho_escolar: 0,
        gremio_estudantil: 0,
        outros_orgaos_colegiados: 0,
        nao_ha_orgaos_colegiados: 0,
  */

      const orgaos_colegiados = [
        "associacao_pais",
        "associacao_pais_mestres",
        "conselho_escolar",
        "gremio_estudantil",
        "outros_orgaos_colegiados",
        "nao_ha_orgaos_colegiados",
      ];
      validarGrupoCampos(
        "orgaos_colegiados",
        'Os órgãos colegiados devem ser preenchidos, caso não haja marque o campo "não há órgãos".',
        orgaos_colegiados
      );

      if (this.formData.educacao_ambiental) {
        /* ambiental_conteudo_curricular: null,
        ambiental_componente_especifico: null,
        ambiental_eixo_estruturante: null,
        ambiental_eventos: null,
        ambiental_projetos_transversais: null,
        ambiental_nenhuma_opcao: null,
        */
        const educacao_ambiental = [
          "ambiental_conteudo_curricular",
          "ambiental_componente_especifico",
          "ambiental_eixo_estruturante",
          "ambiental_eventos",
          "ambiental_projetos_transversais",
          "ambiental_nenhuma_opcao",
        ];
        validarGrupoCampos(
          "educacao_ambiental",
          "Educação ambiental deve ser preenchido.",
          educacao_ambiental
        );
      }
    },

    async save(type) {
      this.validacao();
      if (!this.erros.length > 0) {
        try {
          await this.$services.censoService.saveData(this.formData, "aba10");
          if (type === "next") {
            this.$emit("event", "tab-3");
          } else {
            this.$emit("event", "tab-1");
          }
        } catch (error) {
          this.$handleError(error);
        }
      }
    },
  },
};
</script>
